import { Link } from 'react-router-dom';
import { useEditableGroupOrderCart } from 'src/cart/hooks/useGroupOrderCart';
import { ConsumerBanner } from 'src/shared/design-system/ConsumerBanner';
import { FaExclamationCircle } from 'src/shared/design-system/FontAwesome';
import { Routes } from 'src/shared/Routes';
import { getIdSluggedPath } from 'src/shared/utils/RouteUtilities';
import styled from 'styled-components';
import { Colors, Font } from 'web-common/src/shared/styles';

const BannerText = styled.p`
  color: white;
  font-family: ${Font.Family.SANS};
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  margin: 0%;
`;

const BannerLink = styled(BannerText)`
  font-family: ${Font.Family.SANS};
  font-weight: 400;
  text-decoration: underline;
`;

const BannerContent = styled.div`
  display: flex;
  direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  > * {
    margin: 0 10px;
  }
`;

const BannerIcon = styled.div`
  font-size: 30px;
`;

const StyledFaExclamationCircle = styled(FaExclamationCircle)`
  color: ${Colors.JACKFRUIT};
  font-size: ${Font.Size.XXL};
`;

export const EditingBanner = () => {
  const { resetOrderState, groupOrder } = useEditableGroupOrderCart({});

  const groupOrderId = groupOrder?.id;

  const link = groupOrderId
    ? getIdSluggedPath(Routes.CONSUMER_ORDER_RECEIPT, groupOrderId)
    : Routes.CONSUMER_ACCOUNT_ORDERS;

  return (
    <ConsumerBanner>
      <BannerContent>
        <BannerIcon>
          <StyledFaExclamationCircle />
        </BannerIcon>
        <div>
          <BannerText>
            You are currently editing your order.
            <br />
            To submit, please continue to cart.
            <br />
            <br />
          </BannerText>
          <Link to={link} onClick={resetOrderState}>
            <BannerLink>Click here to cancel editing</BannerLink>
          </Link>
        </div>
      </BannerContent>
    </ConsumerBanner>
  );
};
